import React from "react";
import ReusableModal from "../../../components/Modals/ReusableModal";
import MapV3 from "../../../components/Maps/MapV3";
import CloseSvg from "../../../assets/svgs/CloseSvg";
import moment from "moment";

const Map = ({
  open,
  setOpen,
  uniqueLocations,
  provider,
  providers,
  selectedPatient,
}) => {
  return (
    <ReusableModal open={open} hideHeader>
      <div className="flex justify-between items-center gap-4 p-3 ">
        <p className="text-xl font-bold m-0">Map view</p>
        <button onClick={() => setOpen(false)}>
          <CloseSvg />
        </button>
      </div>
      <div className="px-3 flex gap-6 ">
        <p className="text-md font-medium m-0">
          <b>Provider: </b>
          {provider?.name}
        </p>
        <p className="text-md font-medium m-0">
          <b>Selected Date: </b>
          {moment(provider?.date).format("MM/DD/YYYY")}
        </p>
      </div>
      <div className="h-[calc(100vh-200px)] p-3">
        <MapV3
          locations={uniqueLocations}
          provider={provider}
          providers={providers}
          selectedPatient={null}
        />
      </div>
    </ReusableModal>
  );
};

export default Map;
